export default {
  title: 'Zipcode Management',

  tabs: {
    china: 'China',
    us: 'United States'
  },

  search: {
    keyword: 'Keyword Search',
    keywordPlaceholderChina: 'Zipcode, city, area name',
    keywordPlaceholderUS: 'Zipcode, city, area name',
    administrativeDivision: 'Administrative Division',
    selectProvince: 'Please select province',
    state: 'State',
    allStates: 'All States',
    status: 'Status',
    statusPlaceholder: 'Select status',
    allStatus: 'All Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  actions: {
    addChinaZipcode: 'Add China Zipcode',
    addUSZipcode: 'Add US Zipcode',
    recordsCount: 'Total {count} records',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable'
  },

  table: {
    postalCode: 'Postal Code',
    province: 'Province',
    city: 'City',
    district: 'District/County',
    street: 'Street/Township',
    areaName: 'Area Name',
    state: 'State',
    status: 'Status',
    operation: 'Operation'
  },

  form: {
    addTitle: 'Add Zipcode',
    editTitle: 'Edit Zipcode',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Please enter postal code',
    administrativeDivision: 'Administrative Division',
    selectAdministrativeDivision: 'Please select province/city/district/street',
    stateCity: 'State-City Selection',
    selectStateCity: 'Please select state and city',
    areaName: 'Area Name',
    areaNamePlaceholder: 'Please enter specific area name (optional)',
    areaNameCn: 'Area Name (Chinese)',
    areaNameCnPlaceholder: 'Please enter area name in Chinese (optional)',
    status: 'Status',
    statusPlaceholder: 'Please select status'
  },

  modal: {
    addTitle: 'Add Zipcode',
    editTitle: 'Edit Zipcode'
  },

  statusText: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },

  validation: {
    postalCodeRequired: 'Please enter postal code',
    statusRequired: 'Please select status',
    administrativeDivisionRequired: 'Please select at least district/county level administrative division',
    stateCityRequired: 'Please select state and city',
    stateRequired: 'Please select state',
    cityRequired: 'Please select city'
  },

  messages: {
    checkRequired: 'Please check required fields',
    saveSuccess: 'Saved successfully',
    updateSuccess: 'Updated successfully',
    saveError: 'Failed to save',
    loadError: 'Failed to load zipcode data',
    loadAdministrativeDivisionError: 'Failed to load China administrative division data',
    loadUSAdministrativeDivisionError: 'Failed to load US administrative division data',
    loadUSStatesError: 'Failed to load US states data',
    loadUSCitiesError: 'Failed to load {state} cities data',
    statusToggleSuccess: '{action} successfully',
    statusToggleError: '{action} failed',
    selectToEnable: 'Please select zipcodes to enable',
    selectToDisable: 'Please select zipcodes to disable',
    batchEnableSuccess: 'Batch enable successful',
    batchEnableError: 'Batch enable failed',
    batchDisableSuccess: 'Batch disable successful',
    batchDisableError: 'Batch disable failed'
  },

  confirm: {
    toggleStatus: 'Are you sure you want to {action} this zipcode?',
    toggleStatusContent: 'Zipcode: {postalCode}',
    batchEnable: 'Batch Enable Confirmation',
    batchEnableContent: 'Are you sure you want to enable selected {count} zipcodes?',
    batchDisable: 'Batch Disable Confirmation',
    batchDisableContent: 'Are you sure you want to disable selected {count} zipcodes?'
  }
}